import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, HvlQueryModel } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrPerEmployeeCardsQueryModel')
export class PerEmployeeCardsQueryModel extends HvlQueryModel {

    @EmptyControl()
    @JsonProperty('employeeCardId', Number, true)
    employeeCardId: number = null;

    @EmptyControl()
    @JsonProperty('employeeCardCode', String, true)
    employeeCardCode: string = null;

    @EmptyControl()
    @JsonProperty('perEmployeeSubtypeId', Number, true)
    perEmployeeSubtypeId: number = null;

    @EmptyControl()
    @JsonProperty('peopleId', String, true)
    peopleId: number = null;

    @EmptyControl()
    @JsonProperty('willBeTerminated', Boolean, true)
    willBeTerminated: boolean = null;

    @EmptyControl()
    @JsonProperty('includeCardCodeTextData', Boolean, true)
    includeCardCodeTextData: boolean = null;

    @EmptyControl()
    @JsonProperty('employeeCardCodeList', [String], true)
    employeeCardCodeList: Array<String> = null;
}
